import React from 'react';
import { PopularQuestionsContainer } from './styled';
import QuestionsSubSection from './QuestionsSubSection';
import { useAtomValue } from 'jotai';
import { questionsAtom } from '../atoms';

function PopularQuestions({disabled, getStream}) {
  const randomisedQuestions = useAtomValue(questionsAtom);

  return (
    <PopularQuestionsContainer>
      {
        randomisedQuestions.map((section, index) => (
          <QuestionsSubSection
            key={index}
            index={index}
            section={section}
            disabled={disabled}
            getStream={getStream}
          />
        ))
      }
    </PopularQuestionsContainer>
  )
}
export default PopularQuestions;